"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.queryBonusTypeCombo = queryBonusTypeCombo;
exports.queryGagaAreaCombo = queryGagaAreaCombo;
exports.queryImageAccessDomain = queryImageAccessDomain;
exports.queryMemberLevelCombo = queryMemberLevelCombo;
var _requestPIM = _interopRequireDefault(require("@/utils/requestPIM"));
var request_api_prefix = '/xySysCons';

/**
 * 获取图片访问域名
 */
function queryImageAccessDomain() {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/imageAccessDomain',
    method: 'get'
  });
}

/**
 * 获取会员等级
 */
function queryMemberLevelCombo() {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/memberLevelCombo',
    method: 'get'
  });
}

/**
 * 获取gaga区域
 */
function queryGagaAreaCombo() {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/gagaAreaCombo',
    method: 'get'
  });
}

/**
 * 获取优惠券列表
 */
function queryBonusTypeCombo(params) {
  return (0, _requestPIM.default)({
    url: request_api_prefix + '/exBonusCouponCombo',
    method: 'get',
    params: params
  });
}